export default __webpack_public_path__ + "static/media/the-story-hero.0479d1d0.jpg";